import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { CommonQuestions } from '.';
import { QuestionsAnswers } from '../../../components/QuestionsAnswers';
import { allQuestionAnswer } from '../../../components/QuestionsAnswers/helpCenterQuestions';

export const CommonQuestionRoutes: React.FC = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Route exact path={path} component={CommonQuestions}></Route>
      {allQuestionAnswer.map((questionAnswer) => (
        <Route
          key={questionAnswer.route}
          exact
          path={`${path}${questionAnswer.route}`}
          render={() => (
            <QuestionsAnswers {...questionAnswer}></QuestionsAnswers>
          )}
        />
      ))}
    </>
  );
};
